import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import HeroSection from "@/components/landing/HeroSection";
import { generateNormalizedWebFingerprint } from "@/lib/device/fingerprint";
import { trustedUserApi } from "@/services/trusted-user";

// Simple loading component following project style
const LoadingPage = () => (
  <div className="min-h-screen bg-gradient-to-b from-pure-white to-electric-blue/10 text-midnight-blue flex items-center justify-center">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-burnt-orange mx-auto mb-4"></div>
      <p className="text-midnight-blue/80 text-lg">Đang chuyển hướng...</p>
      <p className="text-midnight-blue/60 text-sm mt-2">
        Vui lòng đợi trong giây lát
      </p>
    </div>
  </div>
);

// Fallback page component with landing page style
const AboutPage = () => (
  <div className="min-h-screen bg-gradient-to-b from-pure-white to-electric-blue/10 text-midnight-blue">
    <HeroSection />
  </div>
);

const UniversalLinkPage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { "*": path } = useParams<{ "*": string }>();

  // Detect device type
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);

  useEffect(() => {
    const platformName = isIOS ? "ios" : isAndroid ? "android" : "desktop";

    // Extract invitation code from path if it matches the pattern
    const invitationCode = path?.includes("invite/")
      ? path.split("invite/")[1]?.split("/")[0]
      : null;

    const handleFingerprintAndRedirect = async () => {
      try {
        // Generate fingerprint
        const fingerprintData =
          await generateNormalizedWebFingerprint(platformName);

        // If we have an invitation code, call the API to update fingerprint
        if (invitationCode) {
          try {
            await trustedUserApi.updateFingerprint({
              invitation_code: invitationCode,
              fingerprint_hash: fingerprintData.hashHex,
            });
            console.log(
              "Fingerprint updated successfully for invitation:",
              invitationCode,
            );
          } catch (apiError) {
            console.error("Failed to update fingerprint:", apiError);
            // Continue with redirect even if API call fails
          }
        }
      } catch (error) {
        console.error("Error generating fingerprint:", error);
      }

      // Redirect after a short delay
      const timeout = setTimeout(() => {
        if (isIOS) {
          // Redirect to iOS App Store
          window.location.href =
            "https://apps.apple.com/vn/app/locuno/id6753800628";
        } else if (isAndroid) {
          // Redirect to Google Play Store
          window.location.href =
            "https://play.google.com/store/apps/details?id=com.locunoapp";
        }
        setIsLoading(false);
      }, 3000);

      return () => clearTimeout(timeout);
    };

    handleFingerprintAndRedirect();
  }, [isIOS, isAndroid, path]);

  return isLoading ? (
    <LoadingPage />
  ) : (
    <>
      <AboutPage />
    </>
  );
};

export default UniversalLinkPage;
